import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { DriverRankingAppliedPenaltyAdminDto } from '@/backend/market'
import { DriverRankingAppliedPenaltyEntity } from '../../domain/entities/DriverRankingAppliedPenaltyEntity'

export class DriverRankingAppliedPenaltyModel extends DriverRankingAppliedPenaltyEntity {
  constructor(data: DriverRankingAppliedPenaltyAdminDto) {
    super()
    mapEntityProperties(this, data)
  }
}
